import { Textarea, TextareaProps } from "@chakra-ui/textarea";
import React from "react";
import { BaseFieldProps, FieldWrapper } from "../FieldWrapper/FieldWrapper";

interface TextAreaProps extends BaseFieldProps {}

export const TextArea = ({
  name,
  label,
  id,
  helperText,
  infoText,
  isRequired,
  ...textAreaProps
}: TextAreaProps & TextareaProps) => {
  return (
    <FieldWrapper
      name={name}
      id={id}
      label={label}
      helperText={helperText}
      infoText={infoText}
      isRequired={isRequired}
    >
      {({ field }) => (
        <Textarea
          {...field}
          {...textAreaProps}
          rows={textAreaProps.rows ?? 5}
        />
      )}
    </FieldWrapper>
  );
};
